import { withRouter } from 'react-router-dom';
import { Link, makeStyles } from '@material-ui/core';
import T from "../../untils/gTranslate"

const useStyles = makeStyles({

    SpanStyle: {
        fontSize: "14px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "24px",
        textAlign: "center",
        display: "grid"
        // "@media (min-width:1500px)": {
        //     marginLeft: "650px"
        // },
        // "@media screen and (min-width:800px) and (max-width:1500px)": {
        //     marginLeft: "280px"
        // }
    }
})

function Foot(props) {

    const classes = useStyles();

    return (
        <footer>
            <div className="version-show">
                <span className={classes.SpanStyle}>
                    <span>
                        {`${T("copyright")}© 2008${T("dash")}${props.year}${T("dash")}${T("limited")} ${T("all_rights_reserved")}`}
                    </span>
                    <span>
                        <Link color="inherit" href={T("disclaimer_link")}> &nbsp;{T("disclaimer")}</Link> |
                        <Link color="inherit" href={T("pics_link")}> &nbsp;{T("pics")}</Link>
                    </span>
                </span>
            </div >
        </footer>
    );
}

export default withRouter(Foot);